export default __webpack_public_path__ + "static/media/weightlosswithfamily@3x.d5c4b8e6.jpg";